<template>
  <v-dialog v-model="dialog" lazy absolute>
    <v-btn outline large class="mx-0 secondary secondary--text" slot="activator">
      <slot>Marcar como realizada</slot>
    </v-btn>
    <v-card>
      <v-card-title>
        <div class="title">Marcar tarefa como realizada?</div>
        <div class="mt-3">Para marcar uma tarefa como realizada você precisa preencher uma observação referente a tarefa.</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          v-model="form.fields.conteudo"
          label="Observação"
          multi-line
          v-validate="'required'"
          name="observacao"
          data-vv-as="observação"
          :error-messages="errors.has('observacao') ? errors.first('observacao') : []"
        >
        </v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn class="error--text" flat @click.native="descartar">Ainda não</v-btn>
        <v-btn class="secondary--text" flat @click.native="onSubmit" :disabled="isFormInvalid">Sim</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'

  export default {
    props: ['tarefaId', 'imovelId'],
    data () {
      return {
        dialog: false,
        inputKey: Math.random(),
        form: {
          fields: {
            tipo: 'geral',
            conteudo: ''
          }
        }
      }
    },
    computed: {
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    methods: {
      descartar () {
        this.dialog = false
        this.form.fields.conteudo = ''
        this.inputKey = Math.random()
        this.errors.clear()
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            axios.post(`${apiURL}/observacoes/${this.imovelId}`, this.form.fields).then(() => {
              try {
                axios.patch(`${apiURL}/tarefas/realizar/${this.tarefaId}`).then((response) => {
                  this.$store.dispatch('imoveis/loadImovel', { id: this.imovelId }).finally(() => {
                    this.descartar()
                  })
                }).catch((error) => {
                  console.error('Erro ao finalizar tarefa', error)
                  this.$store.dispatch('utils/showSnackbar', {
                    text: 'Servidor indisponível. Tente novamente mais tarde.'
                  })
                }).then(() => {
                  this.$store.dispatch('utils/hideLoading')
                })
              } catch (error) {
                console.error('Erro ao concluir fluxo de realizacao de tarefa', error)
                this.$store.dispatch('utils/hideLoading')
              }
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TarefasRealizar.vue?8085b6fe